import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import IntlMessages from 'lngProvider/IntlMessages';

const ValidatePassword = ({ data }) => {
    var newPasswordHas8Chars = false;
    var newPasswordHasLower = false;
    var newPasswordHasUpper = false;
    var newPasswordHasNumbers = false;
    var newPasswordHasSpecialChars = false;

    const checkPasswordsForRequirements = (values) => {
        if (values.newPassword) {
            if (newPasswordHas8Chars &&
                newPasswordHasLower &&
                newPasswordHasUpper &&
                newPasswordHasNumbers &&
                newPasswordHasSpecialChars) {
                return 'none';
            } else {
                return 'block';
            }
        } else {
            return 'none';
        }
    }

    const meetsLengthRequirement = (password) => {
        newPasswordHas8Chars = password && password.length >= 8;
        return newPasswordHas8Chars;
    }

    const containsLower = (password) => {
        newPasswordHasLower = password && password.match(/(?=.*?[a-z])/) !== null;
        return newPasswordHasLower;
    }

    const containsUpper = (password) => {
        newPasswordHasUpper = password && password.match(/(?=.*?[A-Z])/) !== null;
        return newPasswordHasUpper;
    }

    const containsCorrectCase = (password) => {
        return containsLower(password) && containsUpper(password);
    }

    const containsNumbers = (password) => {
        newPasswordHasNumbers = password && password.match(/(?=.*\d)/) !== null;
        return newPasswordHasNumbers;
    }

    const containsSpecialCharacters = (password) => {
        newPasswordHasSpecialChars = password && password.match(/(?=.*[^A-Za-z0-9])/) !== null;
        return newPasswordHasSpecialChars;
    }

    return (
        <Box display={checkPasswordsForRequirements(data)}>
            <IntlMessages id="changePassword.passwordRequirementTitle" />
            <List dense={true} disablePadding={true}>
                {meetsLengthRequirement(data.newPassword)
                    ?
                    <ListItem dense><ListItemIcon><CheckIcon style={{ color: 'green' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement1" /></ListItemText></ListItem>
                    :
                    <ListItem dense><ListItemIcon><ClearIcon style={{ color: 'red' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement1" /></ListItemText></ListItem>}
                {containsCorrectCase(data.newPassword)
                    ?
                    <ListItem dense><ListItemIcon><CheckIcon style={{ color: 'green' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement2" /></ListItemText></ListItem>
                    :
                    <ListItem dense><ListItemIcon><ClearIcon style={{ color: 'red' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement2" /></ListItemText></ListItem>}
                {containsNumbers(data.newPassword)
                    ?
                    <ListItem dense><ListItemIcon><CheckIcon style={{ color: 'green' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement3" /></ListItemText></ListItem>
                    :
                    <ListItem dense><ListItemIcon><ClearIcon style={{ color: 'red' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement3" /></ListItemText></ListItem>}
                {containsSpecialCharacters(data.newPassword)
                    ?
                    <ListItem dense><ListItemIcon><CheckIcon style={{ color: 'green' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement4" /></ListItemText></ListItem>
                    :
                    <ListItem dense><ListItemIcon><ClearIcon style={{ color: 'red' }} /></ListItemIcon><ListItemText style={{ padding: 0 }}><IntlMessages id="changePassword.requirement4" /></ListItemText></ListItem>}
            </List>
        </Box>
    );
}

export default ValidatePassword;